import React from 'react'
import styled from 'styled-components';
import Mainbg from '../components/common/styled/Mainbg';
import JustifyMenu from '../components/common/styled/JustifyMenu'
import ProductPanel from '../components/nft/ProductPanel'
import ListBox from '../components/nft/ListBox'


const NFTDetailStyle = styled.div`
  width: 1080px;
  margin: auto;
  @media (max-width: 768px) {
    width: 100%;
    padding: 0 20px;
  }
`;

export default function NFTDetail() {
  return (
    <Mainbg>
      <NFTDetailStyle>
        <JustifyMenu padding="25px 0 35px">
          <h2 className="h2">Trias NFT</h2>
          <a href='#/triasnft'>
            Connect Wallet
            <i className="fa fa-arrow-right"></i>
          </a>
        </JustifyMenu>
        <ProductPanel></ProductPanel>
        <ListBox></ListBox>
      </NFTDetailStyle>
    </Mainbg>
  )
}
